import { PrestacaoConta } from './prestacao-conta.model';

export class AnexoPrestacaoConta {
    public id: number;
    public id_prestacao_conta: number;
    public nome_arquivo: string;
    public tamanho_arquivo: number;
    public tipo: string;
    public extensao: string;
    public nome_upload: string;
    public data_inclusao: Date;


    public prestacao_conta: PrestacaoConta;
}


// WEBPACK FOOTER //
// ./src/app/entity/anexo-prestacao-conta.model.ts